var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoronavirusWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.111 20.8982C19.6896 20.4361 21.4053 17.9712 20.9432 15.3926C20.4812 12.814 18.0162 11.0983 15.4376 11.5603C12.8591 12.0224 11.1433 14.4874 11.6054 17.066C12.0675 19.6445 14.5324 21.3603 17.111 20.8982ZM17.3392 22.1715C20.621 21.5834 22.8047 18.4462 22.2166 15.1644C21.6285 11.8826 18.4913 9.69889 15.2095 10.287C11.9276 10.8751 9.74394 14.0123 10.332 17.2941C10.9202 20.576 14.0574 22.7597 17.3392 22.1715Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4113 17.0462C16.8797 16.9622 17.1913 16.5145 17.1074 16.046C17.0235 15.5776 16.5757 15.266 16.1073 15.3499C15.6389 15.4339 15.3272 15.8816 15.4112 16.35C15.4951 16.8184 15.9429 17.1301 16.4113 17.0462ZM18.5839 15.7815C18.814 17.0653 17.9597 18.2926 16.6759 18.5226C15.392 18.7527 14.1647 17.8985 13.9347 16.6146C13.7046 15.3308 14.5589 14.1035 15.8427 13.8734C17.1266 13.6434 18.3538 14.4976 18.5839 15.7815Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5474 6.42651C14.7818 6.3845 14.9378 6.16042 14.8958 5.926C14.8537 5.69159 14.6297 5.53561 14.3952 5.57762C14.1608 5.61962 14.0049 5.84371 14.0469 6.07813C14.0889 6.31254 14.313 6.46852 14.5474 6.42651ZM14.7756 7.69986C15.7132 7.53182 16.3371 6.63548 16.1691 5.69782C16.0011 4.76015 15.1047 4.13624 14.1671 4.30427C13.2294 4.4723 12.6055 5.36865 12.7735 6.30631C12.9415 7.24398 13.8379 7.86789 14.7756 7.69986Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2503 8.96441C21.4847 8.92241 21.6406 8.69832 21.5986 8.4639C21.5566 8.22949 21.3325 8.07351 21.0981 8.11552C20.8637 8.15753 20.7077 8.38161 20.7497 8.61603C20.7917 8.85044 21.0158 9.00642 21.2503 8.96441ZM21.4784 10.2378C22.4161 10.0697 23.04 9.17338 22.872 8.23572C22.704 7.29805 21.8076 6.67414 20.8699 6.84218C19.9323 7.01021 19.3084 7.90655 19.4764 8.84421C19.6444 9.78188 20.5408 10.4058 21.4784 10.2378Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.53593 11.3597C8.77034 11.3177 8.92632 11.0936 8.88431 10.8592C8.8423 10.6248 8.61822 10.4688 8.3838 10.5108C8.14939 10.5529 7.99341 10.7769 8.03542 11.0114C8.07742 11.2458 8.30151 11.4017 8.53593 11.3597ZM8.76411 12.6331C9.70178 12.4651 10.3257 11.5687 10.1577 10.631C9.98962 9.69338 9.09328 9.06947 8.15562 9.2375C7.21795 9.40553 6.59404 10.3019 6.76207 11.2395C6.9301 12.1772 7.82645 12.8011 8.76411 12.6331Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1021 25.6224C10.3365 25.5804 10.4925 25.3563 10.4505 25.1219C10.4085 24.8875 10.1844 24.7315 9.94999 24.7735C9.71558 24.8155 9.5596 25.0396 9.60161 25.274C9.64362 25.5085 9.8677 25.6644 10.1021 25.6224ZM10.3303 26.8958C11.268 26.7277 11.8919 25.8314 11.7238 24.8937C11.5558 23.9561 10.6595 23.3322 9.72181 23.5002C8.78414 23.6682 8.16023 24.5646 8.32826 25.5022C8.4963 26.4399 9.39264 27.0638 10.3303 26.8958Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9844 14.7117C27.2188 14.6697 27.3748 14.4456 27.3328 14.2112C27.2908 13.9767 27.0667 13.8208 26.8323 13.8628C26.5978 13.9048 26.4419 14.1289 26.4839 14.3633C26.5259 14.5977 26.75 14.7537 26.9844 14.7117ZM27.2126 15.985C28.1502 15.817 28.7741 14.9206 28.6061 13.983C28.4381 13.0453 27.5417 12.4214 26.6041 12.5894C25.6664 12.7575 25.0425 13.6538 25.2105 14.5915C25.3786 15.5291 26.2749 16.153 27.2126 15.985Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1266 25.0742C18.361 25.0321 18.517 24.8081 18.475 24.5736C18.433 24.3392 18.2089 24.1833 17.9745 24.2253C17.7401 24.2673 17.5841 24.4914 17.6261 24.7258C17.6681 24.9602 17.8922 25.1162 18.1266 25.0742ZM18.3548 26.3475C19.2925 26.1795 19.9164 25.2831 19.7484 24.3455C19.5803 23.4078 18.684 22.7839 17.7463 22.9519C16.8087 23.1199 16.1847 24.0163 16.3528 24.954C16.5208 25.8916 17.4171 26.5155 18.3548 26.3475Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.75217 18.2866C7.98659 18.2446 8.14257 18.0205 8.10056 17.7861C8.05855 17.5517 7.83447 17.3957 7.60005 17.4377C7.36563 17.4797 7.20966 17.7038 7.25166 17.9382C7.29367 18.1726 7.51776 18.3286 7.75217 18.2866ZM7.98036 19.56C8.91802 19.3919 9.54194 18.4956 9.3739 17.5579C9.20587 16.6203 8.30953 15.9963 7.37186 16.1644C6.4342 16.3324 5.81029 17.2288 5.97832 18.1664C6.14635 19.1041 7.0427 19.728 7.98036 19.56Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7898 11.2019L14.0292 6.95743L15.3026 6.72925L16.0632 10.9737L14.7898 11.2019Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1314 23.6355L16.7232 21.3576L17.9966 21.1295L18.4048 23.4073L17.1314 23.6355Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5903 14.9575L21.4969 15.8703L21.2687 14.5969L26.3621 13.6842L26.5903 14.9575Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3101 17.6958L9.2042 18.0731L8.97601 16.7998L11.0819 16.4224L11.3101 17.6958Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5742 11.3788L20.0354 9.27964L21.0971 10.0187L19.6359 12.1179L18.5742 11.3788Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6372 24.5553C10.344 24.3512 10.2718 23.9481 10.4759 23.6549L12.4482 20.8214C12.6522 20.5282 13.0554 20.456 13.3486 20.6601V20.6601C13.6417 20.8642 13.714 21.2673 13.5099 21.5605L11.5376 24.394C11.3335 24.6872 10.9304 24.7594 10.6372 24.5553V24.5553Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1931 21.6685C23.989 21.9617 23.5859 22.034 23.2927 21.8299L21.0073 20.2391C20.7141 20.035 20.6418 19.6319 20.8459 19.3387V19.3387C21.05 19.0455 21.4531 18.9732 21.7463 19.1773L24.0317 20.7681C24.3249 20.9722 24.3972 21.3753 24.1931 21.6685V21.6685Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5114 12.9558C11.3073 13.249 10.9042 13.3212 10.611 13.1171L9.56124 12.3864C9.26805 12.1823 9.19581 11.7792 9.39989 11.486V11.486C9.60397 11.1928 10.0071 11.1206 10.3003 11.3247L11.3501 12.0554C11.6433 12.2595 11.7155 12.6626 11.5114 12.9558V12.9558Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.942 22.6602C25.1764 22.6182 25.3324 22.3941 25.2903 22.1597C25.2483 21.9253 25.0243 21.7693 24.7898 21.8113C24.5554 21.8533 24.3994 22.0774 24.4415 22.3118C24.4835 22.5462 24.7075 22.7022 24.942 22.6602ZM25.1701 23.9336C26.1078 23.7655 26.7317 22.8692 26.5637 21.9315C26.3957 20.9939 25.4993 20.3699 24.5617 20.538C23.624 20.706 23.0001 21.6024 23.1681 22.54C23.3361 23.4777 24.2325 24.1016 25.1701 23.9336Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoronavirusWhite);
export default __webpack_public_path__ + "static/media/CoronavirusWhite.e5a5804ce0aec8ccae32df05977287de.svg";
export { ForwardRef as ReactComponent };